// sections/TrustAndSafetySection.tsx
import React from "react";
import { Container, Row, Col, Card, CardBody } from "reactstrap";
import { Shield, DollarSign, Award } from "lucide-react";

// Import images
import safetyResource from "./images/verified-contractor.webp";
import paymentProtection from "./images/payment-protection.png";
import projectManagement from "./images/project-management.jpg";

const TrustAndSafetySection: React.FC = () => {
  const safetyCards = [
    {
      icon: Shield,
      title: "Verified Professionals",
      image: safetyResource,
      items: [
        "Background checks",
        "License verification",
        "Insurance coverage",
        "Past work history",
      ],
    },
    {
      icon: DollarSign,
      title: "Payment Protection",
      image: paymentProtection,
      items: [
        "Secure payments",
        "Milestone releases",
        "No upfront fees",
        "Money-back guarantee",
      ],
    },
    {
      icon: Award,
      title: "Project Management",
      image: projectManagement,
      items: [
        "Satisfaction guaranteed",
        "Project Management",
        "Dispute resolution",
        "Customer support",
      ],
    },
  ];

  return (
    <section className="py-5 bg-white">
      <Container>
        <h2 className="fs-1 fw-bold text-center mb-5">
          Trust & Safety Guaranteed
        </h2>
        <Row className="g-4">
          {safetyCards.map((card, index) => (
            <Col key={index} md={4}>
              <Card className="shadow-sm hover-shadow mb-0">
                <div className="position-relative">
                  <img
                    src={card.image}
                    alt={card.title}
                    className="card-img-responsive"
                  />
                  <div className="card-img-overlay">
                    <card.icon className="feature-icon" />
                  </div>
                </div>
                <CardBody className="p-4">
                  <h3 className="fs-5 fw-semibold mb-4">{card.title}</h3>
                  <ul className="list-unstyled text-muted">
                    {card.items.map((item, i) => (
                      <li key={i} className="mb-2">
                        ✓ {item}
                      </li>
                    ))}
                  </ul>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default TrustAndSafetySection;